window.__litium = window.__litium || {};
export default window.__litium.constants;

export const BREAKPOINT_FOR_MOBILE_MENU = 1199;